import { ky } from './ky';
import { AccountDto } from './account';
import { GeoLocation, JiBunAddress, ListResponse, StreetAddress } from './common';
import { FileDto } from './file';

export interface PlaceDto {
  id: number;
  name: string;
  caption: string;
  owner?: AccountDto;
  jiBunAddress?: JiBunAddress;
  streetAddress?: StreetAddress;
  location?: GeoLocation;
  certificationImage?: FileDto;
  likeCount?: number;
  shareCount?: number;
  feedCount?: number;
  isLike?: boolean;
  representativeImageUrl?: string;
}

export interface SearchPlaceParams {
  name: string;
}

export default class PlaceService {

  async get(id: number) {
    return await ky.get(`v1/places/${id}`).json() as PlaceDto;
  }

  async search(params: SearchPlaceParams) {
    return await ky.get('v1/places', {
      searchParams: params
    }).json() as ListResponse<PlaceDto>;
  }

}
